<template>
  <AppStoryCarousel
    v-if="data.items && data.items.length"
    class="app-content-block-story-image-carousel"
    :slides="data.items"
    :unique-id="uid"
  />
</template>

<script>
import AppStoryCarousel from '@/components/partials/AppStoryCarousel.vue';

export default {
  name: 'AppContentBlockStoryImageCarousel',
  components: { AppStoryCarousel },
  props: {
    uid: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-content-block-story-image-carousel {
  margin: 20px 0 20px 16px;

  @media (min-width: vars.$tablet-break-point) {
    margin: 40px 0;
  }
}
</style>
